import { FirebaseAuthentication } from "@capacitor-firebase/authentication";

import { EmailCredentials } from "~applications";

import { mapSignInError } from "./map-sign-in-error";

export async function signInWithGoogle(): Promise<void> {
  try {
    await FirebaseAuthentication.signInWithGoogle({
      mode: "popup",
    });
  } catch (error) {
    throw mapSignInError(error);
  }
}

export async function signUpWithGoogle(): Promise<void> {
  try {
    await FirebaseAuthentication.linkWithGoogle({ mode: "popup" });
  } catch (error) {
    throw mapSignInError(error);
  }
}

export async function signInWithEmail(
  credentials: EmailCredentials,
): Promise<void> {
  try {
    await FirebaseAuthentication.signInWithEmailAndPassword(credentials);
  } catch (error) {
    throw mapSignInError(error);
  }
}

export async function signUpWithEmail(
  credentials: EmailCredentials,
): Promise<void> {
  try {
    await FirebaseAuthentication.linkWithEmailAndPassword(credentials);
  } catch (error) {
    throw mapSignInError(error);
  }
}

export async function sendPasswordResetEmail(email: string): Promise<void> {
  try {
    await FirebaseAuthentication.sendPasswordResetEmail({ email });
  } catch (error) {
    throw mapSignInError(error);
  }
}
